import { useCallback, useRef, useState, useEffect } from 'react';

export const useHttpClient = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  // si on va trop vite on peut avoir changer de page avant la fin de l'appel, donc erreur
  const activeHttpRequests = useRef([]);

  const sendRequest = useCallback(
    async (url, method = "GET", body = null, headers = {}) => {
      setIsLoading(true);
      const httpAbortCtrl = new AbortController();
      activeHttpRequests.current.push(httpAbortCtrl);
      try {
        const response = await fetch(
            url,
            {
                method,
                body,
                headers,
                signal: httpAbortCtrl.signal
            }
        );

        const responseData = await response.json();
        /*this keeps every controller except for the controller wich was used in this request */
        activeHttpRequests.current = activeHttpRequests.current.filter(
          reqCtrl => reqCtrl !== httpAbortCtrl
        );

        if (!response.ok) {
          throw new Error(responseData.message);
        }

        setIsLoading(false);
        return responseData;
      } catch (err) {
        setError(err.message);
        setIsLoading(false);
        throw err;
      }
    },
    []
  );

  const clearError = () => {
    setError(null);
  };

  /*the first argument is a function, it is only runs when a component mounts
  but in this first function when you return a function, this reurn function 
  is executed as a cleanup function before the next time useEffect runs again
  or when the component that uses le custom Hook unMounts */
  useEffect(() => {
    return () => {
      activeHttpRequests.current.forEach(abortCtrl => abortCtrl.abort());
    };
  }, []);

  return { isLoading, error, sendRequest, clearError };
};
